import React from "react";
import CRMCommunicationsHub from "../../../components/agent/crm/CRMCommunicationsHub";
import "../../../styles/modern-design-system.css";

export default function CRMCommunicationsPage() {
  return (
    <div className="max-w-[1400px] mx-auto">
            {/* Header */}
            <div className="flex flex-col gap-4 justify-between mb-4 md:flex-row md:items-center animate-fade-in-up">
              <div>
                <h1 className="text-xl font-bold tracking-tight leading-tight text-black sm:text-2xl lg:text-3xl text-balance">
                  Communications Hub
                </h1>
                <p className="mt-1 text-sm text-gray-600 sm:text-base">
                  Manage all client communications and chat messages
                </p>
              </div>
            </div>

            {/* Communications Hub Content */}
            <CRMCommunicationsHub />
    </div>
  );
}
